import React from 'react'

const Copyright = () => {
    return  <ul className="copyright">
    <li>&copy; FRT</li><li>Maintened by <a href="https://demecko.com">demecko.com</a></li>
</ul>
}

export default Copyright